import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import "./utils/i18n.utils";
import React from "react";

async function enableMocking() {
  if (process.env.NODE_ENV !== "development") {
    return;
  }
  return;

  const { worker } = await import("./mocks/browser");

  // `worker.start()` returns a Promise that resolves
  // once the Service Worker is up and ready to intercept requests.
  return worker.start();
}

enableMocking().then(() => {
  const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
  root.render(
    // <React.StrictMode>
    <App />
    // </React.StrictMode>
  );
});
